import Badge from '@klv/atoms/badge';
import Icon from '@klv/atoms/icon';
import Button from '@klv/atoms/button';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/universalMenuItem.module.scss';

import type { IUniversalMenuItem } from './types';

export const UniversalMenuItem = <T extends React.ElementType = 'a'>({
  as,
  backgroundColor,
  badge = {
    color: 'charcoal',
    text: '',
  },
  callToAction,
  children,
  childItems,
  className,
  description,
  featured = false,
  href,
  iconName,
  image,
  label,
  locale,
  mobileOrder,
  order,
  position,
  trailingMark = false,
  type,
  width,
  button,
  ...props
}:
IUniversalMenuItem<T>
& Omit<React.ComponentPropsWithoutRef<T>, keyof IUniversalMenuItem<T>>) => {
  let Component = as || 'a';
  const hasImage = image && image?.sourceUrl;
  const isBanner = button && button?.buttonText;
  if (isBanner) {
    Component = 'div';
  }

  return (
    <Component
      className={generateClassName([
        className,
        styles.universalMenuItem,
        featured && styles.featured,
        backgroundColor && styles[backgroundColor],
        isBanner && styles.isBanner,
      ])}
      href={href}
      {...props}
    >
      {children ? children : (
        <>
          <div>
            {hasImage && (
              <div className={styles.imageContainer}>
                <img alt={image?.altText} className={styles.image} loading='lazy' src={image?.sourceUrl} />
              </div>
            )}
            <div className={styles.iconAndLabelContainer}>
              {iconName && (
                <Icon className={styles.icon} color='currentColor' iconName={iconName} size={1.4} />
              )}
              {(label || children || trailingMark) && (
                <div>
                  {label ? label : null}
                  {trailingMark && (
                    <span className={styles.trailingMark} />
                  )}
                </div>
              )}
              {badge?.text && badge?.color && (
                <Badge color={badge.color} text={badge.text} />
              )}
            </div>
            {description && (
              <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
            )}
          </div>
          {button?.buttonText && (
            <Button
              text={button?.buttonText ? button.buttonText : ''}
              url={button?.buttonUrl ? button?.buttonUrl : ''}
              variant="ghost"
              className={styles.button}
            />
          )}
        </>
      )}
    </Component>
  );
};
